import { Box, Tab, Tabs } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import { selectEnableFirmFeatureSet, selectIsOwner, selectIsSupport } from "redux/slices/session";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const Import = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSupport = useAppSelector(selectIsSupport);
  const isOwner = useAppSelector(selectIsOwner);
  const hasFirmFeatureSet = useAppSelector(selectEnableFirmFeatureSet);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Tabs
        value={
          location.pathname.split("/").slice(-1)[0] === "import" ? "history" : location.pathname.split("/").slice(-1)[0]
        }
        onChange={(_evt, v) => {
          navigate(v);
        }}>
        {hasFirmFeatureSet && (isSupport || isOwner) && <Tab value="firms" label="Firms" />}
        <Tab value="history" label="History" />
      </Tabs>
      <Box sx={{ minHeight: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Import;
